export var VERSION = '1.14.0';
//# sourceMappingURL=version.js.map